import { useAnalytics, TRACK_EVENTS } from '@/composables/analytics'

export function experimentViewed (assignment) {
  if (!assignment) return

  const analytics = useAnalytics()

  analytics
    .track(TRACK_EVENTS.EXPERIMENT_VIEWED,
      {
        experiment_id: assignment.experiment,
        experiment_name: assignment.featureFlag,
        variation_id: String(assignment.variation),
        subject_id: assignment.subject,
        subject_type: assignment.subjectAttributes?.subject_type,
        assignment_timestamp: assignment.timestamp,
      },
      { eventVersion: 1 }
    )
}
